import FadeUp from "../components/FadeUp";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";

const ATELIER_HERO = "/atelier-1.jpg";
const BOUTIQUE = "/atelier-2.jpg";
const LOUNGE = "/atelier-3.jpg";
const MODERN = "/atelier-4.jpg";

const copy = {
  intro: {
    it: "Per Lei Bridal è un atelier multimarca con sede a Milano, che propone una selezione curata di abiti da sposa e da cerimonia firmati da designer. Crediamo che ogni abito debba rispecchiare l'individualità, lo stile personale e la libertà di scegliere.",
    en: "Per Lei Bridal is a multi-brand atelier based in Milan, offering a curated selection of wedding and formal dresses by designers. We believe every dress should reflect individuality, personal style and the freedom to choose.",
    zh: "Per Lei Bridal 是一家位于米兰的多品牌工作室，精选设计师品牌婚纱与礼服。我们相信每一件礼服都应体现个性、个人风格与自由选择的权利。",
  },
  curatedTitle: { it: "SELEZIONATI CON CURA", en: "CAREFULLY CURATED", zh: "精心甄选" },
  curated: {
    it: "Dalle silhouette minimaliste ai dettagli più ricercati, ogni abito viene selezionato per il suo design distintivo, la qualità delle lavorazioni e l'eleganza senza tempo. La nostra collezione celebra diverse interpretazioni della bellezza bridal, senza limitarsi a un unico stile.",
    en: "From minimalist silhouettes to the most refined details, every dress is selected for its distinctive design, the quality of its craftsmanship and its timeless elegance. Our collection celebrates diverse interpretations of bridal beauty, without limiting itself to a single style.",
    zh: "从极简廓形到最精致的细节，每一件礼服都因其独特设计、精湛工艺与永恒优雅而被甄选。我们的系列赞颂新娘之美的多元诠释，而不局限于单一风格。",
  },
  privateTitle: { it: "UN'ESPERIENZA PRIVATA", en: "A PRIVATE EXPERIENCE", zh: "私人体验" },
  private: {
    it: "Il nostro atelier a Milano offre un ambiente intimo e accogliente, dove ogni sposa può esplorare le collezioni con i propri tempi. Attraverso appuntamenti privati e una consulenza personalizzata, rendiamo la scelta dell'abito un'esperienza piacevole e curata in ogni dettaglio.",
    en: "Our Milan atelier offers an intimate and welcoming environment, where every bride can explore the collections at her own pace. Through private appointments and personalized consultations, we make choosing the dress a pleasant experience curated in every detail.",
    zh: "我们的米兰工作室提供私密温馨的环境，每位新娘都可以按自己的节奏探索系列。通过私人预约与个性化咨询，我们将选纱打造成一场细致入微的愉悦体验。",
  },
};

export default function Atelier() {
  const { t, lang } = useLang();
  const L = (o) => o[lang];
  return (
    <div data-testid="atelier-page">
      <section className="pt-40 pb-16 lg:pt-52 lg:pb-24 max-w-[1440px] mx-auto px-6 lg:px-12">
        <FadeUp><p className="eyebrow mb-6">Per Lei Bridal — Milano</p></FadeUp>
        <FadeUp delay={0.1}><h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl">THE ATELIER</h1></FadeUp>
        <FadeUp delay={0.2}>
          <p className="mt-6 max-w-2xl font-serif text-2xl sm:text-3xl leading-relaxed text-charcoal/90">{L(copy.intro)}</p>
        </FadeUp>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 lg:px-12" data-testid="atelier-hero-image">
        <FadeUp>
          <div className="clip-frame aspect-[16/9] lg:aspect-[21/9]">
            <img src={ATELIER_HERO} alt="Atelier Per Lei" className="w-full h-full object-cover spotlight-img" />
          </div>
        </FadeUp>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 lg:px-12 py-24 lg:py-36" data-testid="atelier-curated">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <FadeUp><p className="eyebrow mb-5">{L(copy.curatedTitle)}</p></FadeUp>
            <FadeUp delay={0.1}>
              <div className="clip-frame aspect-[3/4]"><img src={BOUTIQUE} alt="Selezione abiti" className="w-full h-full object-cover" loading="lazy" /></div>
            </FadeUp>
          </div>
          <div className="lg:col-span-7 lg:col-start-6 flex flex-col justify-center">
            <FadeUp><p className="font-serif text-2xl sm:text-3xl leading-relaxed text-charcoal/90">{L(copy.curated)}</p></FadeUp>
          </div>
        </div>
      </section>

      <section className="bg-warm py-24 lg:py-32" data-testid="atelier-private">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 grid gap-14 lg:grid-cols-2 items-center">
          <FadeUp>
            <p className="eyebrow mb-5">{L(copy.privateTitle)}</p>
            <p className="mt-6 font-serif text-2xl sm:text-3xl leading-relaxed text-charcoal/90 max-w-lg">{L(copy.private)}</p>
            <FadeUp delay={0.15}>
              <Link to="/appuntamenti" className="btn-solid mt-10 inline-flex" data-testid="atelier-book-cta">
                {t("nav.book")}
              </Link>
            </FadeUp>
          </FadeUp>
          <FadeUp delay={0.15}>
            <div className="grid grid-cols-2 gap-6">
              <div className="clip-frame aspect-square"><img src={LOUNGE} alt="Salone privato" className="w-full h-full object-cover" loading="lazy" /></div>
              <div className="clip-frame aspect-square mt-10"><img src={MODERN} alt="Sala prove" className="w-full h-full object-cover" loading="lazy" /></div>
            </div>
          </FadeUp>
        </div>
      </section>
    </div>
  );
}
